import { useEffect, useState } from 'react';
import { Container, Grid, Typography, Divider, Paper, CircularProgress }from '@material-ui/core';
import dateFormat from 'dateformat';
import NumberFormat from 'react-number-format';
import { LogoHorizontal, ManheimRepairifyLogo, CarvanaRepairifyLogo } from '../components/Logo';
import { useOrderContext } from '../context/OrderContext';
import { orderActionTypes, OrderStatus } from '../app/enums';
import PrintOrderItem from '../components/Order/PrintOrderItem';
import { Orders, Searches } from '../api/api';
import { useUserContext } from '../context/UserContext';
import { themes } from '../app/enums';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    container: {
      padding: 20,
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

export const OrderDetails = () => {
  const classes = useStyles(); 
  const { state, dispatch } = useOrderContext();
  const [ loading , setLoading ] = useState(true);
  const user = useUserContext();

  useEffect(() => {
    Orders.getOrder(state.orderId)
      .then((orderDetails) => {
        dispatch({ type: orderActionTypes.LOAD_ORDER, order: orderDetails})
        
        orderDetails.items.forEach((item) => {
          Searches.getSearch(item.searchId)
            .then((search) => {
              dispatch({ 
                type: orderActionTypes.LOAD_SEARCH_INFO, 
                search: search,
                orderItemId: item.id 
              })
            })
        })
    
        setLoading(false);
      })
      .catch((error) => {
        console.log('Order details error', error)
      }) 
  },[state.orderId])

  let formattedDate = state.displayOrder.createdAt ? dateFormat(new Date(state.displayOrder.createdAt), "mmm dd, yyyy") : ''
  
  let items = state.itemCount > 1 
    ? <span>({state.itemCount} Items)</span>
    : <span>({state.itemCount} Item)</span>

  let logo = <LogoHorizontal />
  
  if(user.state.userTheme === themes.MANHEIM){
    logo = <ManheimRepairifyLogo />
  } else if(user.state.userTheme === themes.CARVANA){
    logo = <CarvanaRepairifyLogo />
  }

  return (
    <div>
      <Container 
        component="main" 
        maxWidth="md" 
        className={classes.container}
      >
        <Paper className={classes.container} elevation={3}>
          { logo }
          { loading 
            ? <CircularProgress color="primary" /> 
            : 
            <Grid>
              <Grid container className={classes.gridSpacer} />
              <Grid container spacing={0}>
                <Typography variant="h6" style={{ fontWeight: 600 }} >Order Details</Typography>   
              </Grid> 
              <Grid container justifyContent="space-between" direction="column">
                <Typography>Order Number: {state.displayOrder.orderNumber}</Typography>
                <Typography>Ordered on: {formattedDate}</Typography>
                <Typography>Status: {OrderStatus[state.displayOrder.status as keyof typeof OrderStatus]}</Typography>
              </Grid>
              <Grid container className={classes.gridSpacer} />
              <Divider /> 
              {state.displayOrder.items.map((item, index) => (
                <PrintOrderItem key={index} item={item}/>
              ))}    
              <Grid container className={classes.gridSpacer} />
              <Divider /> 
              <Grid container className={classes.gridSpacer} />
              <Grid container justifyContent="space-between">
                <Typography style={{ fontWeight: 600 }}>
                  Total {items}:
                </Typography>
                <Typography style={{ fontWeight: 600 }}>
                  <NumberFormat 
                    value={state.totalAmount}
                    displayType={'text'} 
                    thousandSeparator={true} 
                    prefix={'$'} 
                    decimalScale={2}
                    fixedDecimalScale={true}
                    />
                </Typography>
              </Grid>
            </Grid>
          }
        </Paper>  
      </Container>
    </div>
  );
};

export default OrderDetails;
